import React from 'react';
import leftImg from './leftBike.svg';
import location from './location.svg';
import { primaryColor, primaryColorBlue } from '../utility/constant';
import {
  FaWhatsapp,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaEnvelope,
} from 'react-icons/fa';
import text from '../utility/images/textWhite.svg';
import lcon from '../utility/images/iconWhite.svg';
import { useNavigate } from 'react-router-dom';

// Gradient
export const heroGradient = `linear-gradient(180deg, ${primaryColor} 0%, ${primaryColorBlue} 100%)`;

export default function Footer({ onlyFooter, footerRef }) {
  const navigation = useNavigate();
  return (
    <div
      ref={footerRef}
      style={{ background: heroGradient }}
      className="text-white"
    >
      {/* Hero Section */}
      {!onlyFooter && (
        <section className="pt-16 mt-[80px] px-4">
          <div className="container mx-auto flex flex-col md:flex-row gap-12 items-center">
            {/* Left Text Section */}
            <div className="flex-1">
              <h1 className="text-3xl md:text-4xl font-bold mb-4">
                Get Started with{' '}
                <span className="text-gray-100">routeBilling</span>
              </h1>

              <h2 className="text-lg md:text-xl font-medium mb-3 text-gray-200">
                Ready to Transform Your Route Operations?
              </h2>

              <p className="text-base leading-relaxed mb-6 text-gray-300 max-w-xl">
                <b>routeBilling</b> is purpose-built for businesses that rely on
                efficient route management—whether you're in delivery,
                distribution, or field services. Our platform provides powerful,
                easy-to-use tools to streamline your daily operations, reduce
                errors, improve cash flow, and drive sustainable growth.
              </p>

              {/* CTA Buttons */}
            </div>

            {/* Right Image Section */}
            <div className="relative flex justify-center items-center">
              <img
                src={location}
                alt="Background Location"
                className="absolute -right-[100px] h-[300px] w-full object-contain z-0 "
              />
              <img
                src={leftImg}
                alt="Delivery Illustration"
                className="relative z-10 right-10 h-auto"
              />
            </div>
          </div>
        </section>
      )}

      {/* Footer Section */}
      <footer
        style={{
          borderTop: `1px solid ${primaryColorBlue}`,
        }}
        className=" px-4"
      >
        <div className="container mx-auto py-10 grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-3">
              <img src={lcon} alt="Logo Icon" style={{ height: '50px' }} />
              <img
                src={text}
                alt="Logo Text"
                style={{ height: '30px' }}
                className="ml-2"
              />
            </div>
            <p className="text-sm text-gray-200">
              Unlock the full potential of your routes and billing with{' '}
              <b>routeBilling</b> — your trusted partner for success.
            </p>
          </div>

          {/* Useful Links */}
          <div>
            <h3 className="text-lg font-semibold mb-3 text-white">
              Useful Links
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => {
                    navigation('/auth/signup');
                  }}
                  className="hover:text-[#0d0d0d] transition-colors"
                >
                  Create Account
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    navigation('/terms_conditions');
                  }}
                  className="hover:text-[#0d0d0d] transition-colors"
                >
                  Terms &amp; Conditions
                </button>
              </li>
            </ul>
          </div>

          {/* Location */}
          <div>
            <h3 className="text-lg font-semibold mb-3 text-white">Location</h3>
            <div className="flex items-start text-sm space-x-2">
              <FaMapMarkerAlt className="mt-1 text-[#ffffff]" />
              <p className="text-gray-200">
                India <br />
                22 Kalgidhar Avenue, Cantt Road, <br />
                Jalandhar, Punjab 144022 <br />
                <strong>94170-33962</strong>
              </p>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-3 text-white">
              Contact Us
            </h3>
            <div className="space-y-2 text-sm">
              <div className="flex items-center space-x-2">
                <FaPhoneAlt className="text-[#ffffff]" />
                <span className="text-gray-200">+91 85589 51962</span>
              </div>
              <div className="flex items-center space-x-2">
                <FaEnvelope className="text-[#ffffff]" />
                <span className="text-gray-200">support@geniusoffice.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          className=" "
          style={{ borderTop: `1px solid ${primaryColorBlue}` }}
        >
          <div className="container mx-auto  py-4 flex flex-col md:flex-row justify-between items-center text-sm text-gray-200">
            <p>
              A product of{' '}
              <span style={{ color: 'white', fontWeight: '600' }}>
                genius office
              </span>{' '}
              © 2025 All rights reserved.
            </p>
            <div className="flex items-center space-x-2 mt-2 md:mt-0">
              <FaWhatsapp className="text-green-500" />
              <span>WhatsApp Number +91 94170 33962</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
